<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {};
  },
  created() {
    if (this.$route.query.organ_id) {
      localStorage.setItem("organ_id", this.$route.query.organ_id);
    }
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });

  },
  methods: {}

}
</script>
